import type { IconBaseProps } from "./Icon";

export default function CheckIcon({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 18}
      height={height ?? 18}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Check</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.55371 18.3633C10.7356 18.3633 11.9059 18.1305 12.9979 17.6782C14.0898 17.2259 15.0819 16.563 15.9177 15.7272C16.7534 14.8915 17.4163 13.8994 17.8686 12.8074C18.3209 11.7155 18.5537 10.5452 18.5537 9.36328C18.5537 8.18138 18.3209 7.01106 17.8686 5.91913C17.4163 4.8272 16.7534 3.83505 15.9177 2.99932C15.0819 2.16359 14.0898 1.50066 12.9979 1.04837C11.9059 0.596073 10.7356 0.363281 9.55371 0.363281C7.16676 0.363281 4.87758 1.31149 3.18975 2.99932C1.50192 4.68715 0.553711 6.97633 0.553711 9.36328C0.553711 11.7502 1.50192 14.0394 3.18975 15.7272C4.87758 17.4151 7.16676 18.3633 9.55371 18.3633ZM9.32171 13.0033L14.3217 7.00328L12.7857 5.72328L8.48571 10.8823L6.26071 8.65628L4.84671 10.0703L7.84671 13.0703L8.62071 13.8443L9.32171 13.0033Z"
        fill="currentColor"
      />
    </svg>
  );
}
